// eslint-disable-next-line import/no-cycle
import AppUtils from '../utils';

const applyFormatting = (
  formattedText,
  containerRef,
  storedRange,
  accId,
  onChange
) => {
  if (!containerRef.current || !storedRange) {
    return;
  }

  let htmlText;

  if (formattedText.startsWith('<') && formattedText.endsWith('>')) {
    htmlText = formattedText;
  } else {
    htmlText = AppUtils.bbCodeToHtml(formattedText, accId);
  }

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlText;

  storedRange.deleteContents();
  storedRange.insertNode(
    tempDiv.firstChild || document.createTextNode(htmlText)
  );

  window.getSelection().removeAllRanges();

  const newContent = AppUtils.htmlToBbCode(
    containerRef.current.innerHTML,
    true
  );
  onChange(newContent);
};

export default {
  applyFormatting,
};
